import { render, staticRenderFns } from "./ViewCompany.vue?vue&type=template&id=e72dc9c8&scoped=true"
import script from "./ViewCompany.vue?vue&type=script&lang=js"
export * from "./ViewCompany.vue?vue&type=script&lang=js"
import style0 from "./ViewCompany.vue?vue&type=style&index=0&id=e72dc9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72dc9c8",
  null
  
)

export default component.exports